/**
 * Guards for Leaflet map operations to avoid errors when the map
 * container is hidden, unmounted, or not fully initialized.
 */

export function isLeafletMapUsable(map) {
  if (!map || map._removed) return false;
  const container = map.getContainer?.();
  if (!container?.isConnected) return false;
  if (!map.getPane?.('mapPane')) return false;
  return true;
}

export function safeLeafletSetView(map, center, zoom, options = { animate: false }) {
  if (!isLeafletMapUsable(map)) return false;

  const apply = () => {
    if (!isLeafletMapUsable(map)) return false;
    try {
      map.invalidateSize({ animate: false, pan: false });
      map.setView(center, zoom, options);
      return true;
    } catch (err) {
      console.warn('Leaflet setView skipped:', err);
      return false;
    }
  };

  if (map._loaded) {
    requestAnimationFrame(apply);
  } else {
    map.whenReady(apply);
  }

  return true;
}

export function createLeafletMap(container, center, zoom, options = {}) {
  if (!container?.isConnected) return null;
  if (container.offsetWidth === 0 && container.offsetHeight === 0) return null;

  const L = options.L;
  if (!L) return null;

  return L.map(container, {
    center,
    zoom,
    ...options.mapOptions,
  });
}
